import { useAxiosGet } from "./useAxiosGet";

export const useCollection = (url, params = {}, enabled = true) => {

    const { data, setData, loading, refetch } = useAxiosGet(url, params, { enabled });

    const items = data?.content ?? data ?? [];

    const updateItem = (id, changes) => {
        setData(prev => {
            if (!prev) return prev;

            const list = prev.content ?? prev;

            const updated = list.map(item =>
                item.id === id ? { ...item, ...changes } : item
            );

            return prev.content
                ? { ...prev, content: updated }
                : updated;
        });
    };

    const addItem = (newItem) => {
        setData(prev => {
            if (!prev) return prev;

            const list = prev.content ?? prev;

            const updated = [newItem, ...list];

            return prev.content
                ? { ...prev, content: updated }
                : updated;
        });
    };

    const removeItem = (id) => {
        setData(prev => {
            if (!prev) return prev;

            const list = prev.content ?? prev;

            const updated = list.filter(item => item.id !== id);

            return prev.content
                ? { ...prev, content: updated }
                : updated;
        });
    };

    return {
        items,
        loading,
        addItem,
        updateItem,
        removeItem,
        refetch
    };
};
